import {
  useApi,
  type SLAFilteringDtoOptions,
  type Slas200Response,
  type SLASortingDtoOptions,
} from '@issuemanager/api-client';
import { ExtendedAxiosError } from '@issuemanager/apps/client/hooks';
import { useQuery } from '@tanstack/react-query';

type Params = {
  sort?: SLASortingDtoOptions;
  filter?: SLAFilteringDtoOptions;
  page?: number;
  limit?: number;
  enabled?: boolean;
};

export function useSLAs(params: Params) {
  const {
    page = 0,
    limit = 10,
    sort = {},
    filter = {},
    enabled = true,
  } = params;

  const api = useApi();

  return useQuery<Slas200Response, ExtendedAxiosError>({
    queryKey: ['slas', sort, filter, page, limit],
    queryFn: () =>
      api.slasApi.slas(sort, filter, page, limit).then((r) => r.data),
    enabled,
    meta: {
      handleError: true,
    },
  });
}
